<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div class="table-responsive-sm" style="padding:0px">
            <table class="table b-table table-striped" style="margin-bottom:0px">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td style="background-color:#f1f1f1">
                        <label class="col-form-label">상품 구분</label>
                      </td>
                      <td class="">
                        <b-form-select id="basicSelect" v-model="productQueryParams.top_type_code"
                          :plain="true"
                          :options="productTypeItems"
                          :value="null">
                        </b-form-select>
                      </td>
                      <td style="background-color:#f1f1f1">
                        <label class="col-form-label">상품명</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="12"><b-form-input id="basicText" type="text" v-model="productQueryParams.keyword" v-on:keyup="$event.keyCode === 13 ? findDrReportOptList() : ''" placeholder="상품명을 입력해주세요."></b-form-input></b-col>
                        </b-row>
                      </td>
                  </tr>
                </tbody>
            </table>
            <div style="float:right; padding:5px">
              <b-button type="submit" variant="success" v-on:click="findDrReportOptList()"><i class="fa fa-dot-circle-o"></i> 검색</b-button>
            </div>
          </div>
        </b-card>

        <b-card>
          <b-row>
            <b-col sm="12">
              <div class="text-center loadingbar" style="margin:220px 0 230px 0">
                <div style="width:200px; margin:0 auto; vertical-align:middle">
                  <b-spinner label="Large Spinner" style="vertical-align:middle"></b-spinner>
                  <span style="vertical-align:middle; padding:5px; font-weight:blod; font-size:20px">Loading...</span>
                </div>
              </div>
            </b-col>
            <b-col sm="12" class="tabledisplay">
              <b-row>
                <b-col sm="2">
                  <span class="pr-"><strong>총 {{items.length}}건</strong></span>
                </b-col>
                <b-col sm="2"></b-col>
                <b-col sm="5"></b-col>
                <b-col md="3">
                  <b-form-group label-cols-sm="5" label="" class="mb-0">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" class="pt-sm-1 tabledisplay" style="padding:0px">
              <b-row>
                <b-col sm="1"></b-col>
                <b-col sm="12">
                  <b-table
                    striped
                    hover
                    :fields="fieldItems"
                    :items="items"
                    :busy="items == 0"
                    :current-page="currentPage"
                    :per-page="perPage"
                    >
                    <div slot="table-busy" class="text-center my-2">
                      <strong>데이터가 없습니다.</strong>
                    </div>
                    <!-- <template slot="price" slot-scope="data">
                      <div>{{Number(data.item.price).toLocaleString()}}</div>
                    </template> -->
                    <template slot="price" slot-scope="data">
                      <div>
                        보안 : {{Number(data.item.security_price).toLocaleString()}}원
                        <br/>
                        일반 : {{Number(data.item.normal_price).toLocaleString()}}원
                      </div>
                    </template>
                    <template slot="dc_price" slot-scope="data">
                      <div>{{data.item.dc_price != null ? Number(data.item.dc_price).toLocaleString()+'('+Number(data.item.discount).toLocaleString()+'%)' : '할인율 없음'}}</div>
                    </template>
                    <template slot="period_name" slot-scope="data">
                      <div>{{data.item.period_code == 'PRDT_PERIOD_1' ? '기간지정' : data.item.period_name}}<br/><span v-if="data.item.period_code == 'PRDT_PERIOD_1'">(<span style="color:#c20000">{{data.item.period_start_date+' ~ '+data.item.period_end_date}}</span>)</span></div>
                    </template>
                    <template slot="dc_price_date" slot-scope="data">
                      <div>{{data.item.dc_price != null ? data.item.dc_start_date+' ~ '+data.item.dc_end_date : '미설정'}}</div>
                    </template>
                    <template slot="custom_button" slot-scope="data">
                      <div style="margin:0 auto">
                        <b-button variant="info" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" href="javascript:void(0)" v-on:click="productResultData(data.item)"><i class="fa fa-hand-o-up"></i> 적용</h5></b-button>
                      </div>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" class="pt-sm-1 tabledisplay">
              <b-row class="pb-sm-2">
                <b-col sm="1"></b-col>
                <b-col sm="12" class="my-1">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="listRows"
                    :per-page="perPage"
                    align="center"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { codeAPI } from '../../common/code.js';

const moment = require("moment");

export default {
  props: {
    productInfoOptions: {
      p_code: '',
      p_name: '',
      p_typename: '',
      price: '',
      discount: 0,
      dc_price: '',
      dc_result_price: '',
    },
    productFormModal: null,
  },
  data(){
    return {
      productTypeItems: [],
      productQueryParams: {
        p_type: 'all',
        menu_code: [], //대메뉴
        sales_type: 'pay',
        type_code: 'all',
        top_type_code: 'all',
        start_date: '',
        end_date: '',
      },
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 30, 50, 100],
      fieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'tdStyle': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'name': {
          'label': '구분',
          'class': 'text-center',
          'tdClass': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'report_name': {
          'label': '상품명',
          'class': 'text-center',
          'tdClass': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        // 'period_name': {
        //   'label': '상품기간',
        //   'class': 'text-center',
        //   'thStyle': {
        //      'vertical-align': 'middle'
        //   }
        // }
      }, {
        'reg_date': {
          'label': '등록일',
          'class': 'text-center',
          'tdClass': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'price': {
          'label': '가격',
          'class': 'text-center',
          'tdClass': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        // 'dc_price': {
        //   'label': '할인가',
        //   'class': 'text-center',
        //   'tdClass': 'user-vmiddle',
        //   'thStyle': {
        //      'vertical-align': 'middle',
        //      'text-align': 'center'
        //   }
        // }
      }, {
        // 'dc_price_date': {
        //   'label': '할인 기간',
        //   'class': 'text-center',
        //   'tdClass': 'user-vmiddle',
        //   'thStyle': {
        //      'vertical-align': 'middle',
        //      'text-align': 'center'
        //   }
        // }
      }, {
        'custom_button': {
          'label': '적용',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }],
      items: [],
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  mounted: function() {
    $(".loadingbar").hide();
    $(".tabledisplay").show();
    var self = this;

    // 검색 셀렉트 박스 상품타입 조회
    codeAPI.selectItemCodeList(self,"RPT_TYPE",3,"productTypeItems");

    setTimeout(function(){
      var selectOptions = self.productTypeItems;
      self.productTypeItems = [];
      self.productTypeItems.push({text: '전체',value: 'all'});
      selectOptions.forEach(function (el, idx, arr){
        var items = {
          text: el.item_name,
          value: el.item_code,
        };
        self.productTypeItems.push(items);
      });
    }, 500);
  },
  watch: {
    productFormModal (newVal, oldVal) {
      var self = this;
      if(newVal){
        self.productQueryParams = {
          p_type: 'all',
          menu_code: [], //대메뉴
          sales_type: 'pay',
          type_code: 'all',
          top_type_code: 'all',
          start_date: '',
          end_date: '',
        };
        // self.findProductSearchList();
        self.findDrReportOptList();
      }
      // self.optRowsData = [];
      // self.pkgRowsData = [];
      // self.$refs.optTable.refresh();
      // self.$refs.pkgTable.refresh();
      // console.log(self.reportOptions);
      // if(self.formModal){
      //   self.reportOptions.optItems.forEach(function (el, idx, arr){
      //     el.rnum = (idx+1);
      //   });
      // }
    },
  },
  methods:{
    // 메소드명 : findProductSearchList()
    // ### 상품 검색 조회 ###
    // 유저를 T_DR_USER DB테이블에서 조회한다.
    //
    // 최초작성 : 2019.09.16
    // 파라미터 :
    //  - Object => productQueryParams(user_id,user_name)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜     작성자   수정내용
    // 2019.09.18  황경현   최초작성
    // *************************
    findProductSearchList() {
      $(".loadingbar").show();
      $(".tabledisplay").hide();
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.productQueryParams));
      var data = new FormData();
      data.append('productObjs', param);

      self.$http.post('/api/select/drOrderProductSearch?access_token=' + token, data, null)
      .then((result) => {
        self.items = result.data;
        console.log(self.items);
        var itemCnt = self.items.length;
        self.items.forEach(function (el, idx, arr){
          el.rnum = itemCnt - (idx);
        });
        $(".loadingbar").hide();
        $(".tabledisplay").show();
      })
    },
    findDrReportOptList() {
      var self = this;
      // var categoryParams = [];
      // self.categoryButtonOptions.forEach(function (el, idx, arr){
      //   var categoryData = {
      //     cate_code: el.item_code
      //   }
      //   if(el.state){
      //     categoryParams.push(categoryData);
      //   }
      // });
      // self.reportPopSearchData.categoryitems = categoryParams;

      self.productQueryParams.categoryitems = [];


      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.productQueryParams));

      var data = new FormData();
      data.append('optObjs', param);

      self.$http.post('/api/select/drReportSearchOptList?access_token=' + token, data, null)
        .then((result) => {
          // self.reportOptions.optItems = result.data;
          // self.reportOptions.optItems.forEach(function (el, idx, arr){
          //   el.rnum = (idx+1);
          // });

          self.items = result.data;
          console.log(self.items);

          var itemCnt = self.items.length;
          self.items.forEach(function (el, idx, arr){
            el.rnum = itemCnt - (idx);
          });
          $(".loadingbar").hide();
          $(".tabledisplay").show();
        })
    },
    findDrReportList() {
      var self = this;
      var menuParams = [];

      // var menuNames = '';
      // self.productTypeItems.forEach(function (el, idx, arr){
      //   if(el.state){
      //     menuParams.push(el.value);
      //   }
      // });

      if(self.productQueryParams.top_type_code != 'all'){
        menuParams.push(self.productQueryParams.top_type_code);
      }
      self.productQueryParams.menu_code = menuParams;

      // this.queryParams.r_type = this.dr_rtype;
      let token = sessionStorage.getItem("myToken");
      let param = encodeURI(JSON.stringify(self.productQueryParams));

      let data = new FormData();
      data.append('objs', param);

      this.$http.post('/api/select/drReportList?access_token=' + token, data, null)
        .then((result) => {
          self.items = result.data;
          console.log(self.items);

          var itemCnt = self.items.length;
          self.items.forEach(function (el, idx, arr){
            el.rnum = itemCnt - (idx);
          });
          $(".loadingbar").hide();
          $(".tabledisplay").show();

          // this.searchReportCount = self.items.length.toLocaleString();

          // self.items.forEach(function (el, idx, arr){
          //   el.rnum = self.items.length - (idx);
          //   el.selectchecked = false;
            // var categorydata = el.category_alldatas.split(',')
            // var categorytags = "";
            // categorydata.forEach(function (el, idx, arr){
            //   categorytags += "<span class='badge badge-info' style='color:#ffffff; font-size:12px'>"+el+"</span>&nbsp;&nbsp;"
            // });
            // el.categorytag = categorytags;
          // });

          // self.selectCateItems.forEach(function (el, idx, arr){
          //   if(el.value == self.queryParams.type_code){
          //     self.searchData.typeCodeName = el.text;
          //   }
          // });
          // self.searchData.menuNames = menuNames;
          // self.searchData.startday = self.queryParams.start_date;
          // self.searchData.endday = self.queryParams.end_date;
          // self.searchData.keyword = self.queryParams.keyword;
          // self.searchData.dayAllCheck = self.queryParams.day_code == 'dayall';
        })
    },
    productResultData(productdata) {
      this.$emit('childs-event', productdata);
    },
  },
}
</script>


<style scoped>
.user-vmiddle {vertical-align: middle;}
</style>



// WEBPACK FOOTER //
// src/views/order/ProductInfoModal.vue